
import { SuiteModel } from '../../Models/suite-model';
import { Utilities } from 'src/app/utilities';
import { RestService } from 'src/app/Services/rest.service';
export class SuiteMock {

  public static models: SuiteModel[];
  private static idCounter = 0;
  constructor(private rest: RestService) { }
  public static initMocks() {
    SuiteMock.models = [];
    SuiteMock.models.push({ id: "wvwverbt4b4tb", suiteId: ++this.idCounter, name: "Suite 2", type: "sutie" });
  }
  public static findByObjectId(id: string): SuiteModel {
    let m = SuiteMock.models;
    for (let i = 0; i < m.length; i++) {
      if (id == m[i].id) return m[i];
    }
    return null;
  }
  public static addNewStep(step: SuiteModel) {
    step.id = Utilities.makeid(10);
    step.suiteId = ++this.idCounter;
    SuiteMock.models.push(step);
  }
  public static findById(id: number): SuiteModel {
    let m = SuiteMock.models;
    for (let i = 0; i < m.length; i++) {
      if (id == m[i].suiteId) return m[i];
    }
    return null;
  }
  public static getItems(): SuiteModel[] {
    return SuiteMock.models;
  }
  public static deleteModel(model: SuiteModel) {
    let m = SuiteMock.models;
    for (let i = 0; i < m.length; i++) {
      if (model.id == m[i].id) {
        SuiteMock.models.splice(i, 1);
      }
    }
  }
}
